export const getAppStateSliceKey = ({ appStateSliceKey }) => appStateSliceKey;
export const getChartState = ({ appStateSliceKey, ...state }) => state[appStateSliceKey];
